import { getGlobalLogger } from '@zg-rentals/logger-browser';

const logger = getGlobalLogger('adwords/events');

// Define types for Google AdWords conversion tracking
interface GoogleConversionOptions {
  onload_callback?: () => void;
}

interface GoogleAdWordsWindow extends Window {
  google_conversion_id?: number;
  google_conversion_label?: string;
  google_remarketing_only?: boolean;
  google_conversion_format?: string;
  google_trackConversion?: (options: GoogleConversionOptions) => void;
}

function conversion(conversionLabel: string, url?: string): void {
  if (!conversionLabel) {
    return;
  }

  if (window) {
    const w = window as GoogleAdWordsWindow;
    w.google_conversion_id = 848246526;
    w.google_conversion_label = conversionLabel;
    w.google_remarketing_only = false;

    w.google_conversion_format = '3';
    const opt: GoogleConversionOptions = {};
    opt.onload_callback = function () {
      if (typeof url !== 'undefined') {
        window.location.href = url;
      }
    };

    const conv_handler = w.google_trackConversion;
    if (typeof conv_handler === 'function') {
      conv_handler(opt);
    }
  }
  logger.debug({ conversionLabel, url }, 'google adwords conversion');
}

interface TrackingParams {
  trusted?: boolean;
  isApartmentBldg?: boolean;
}

export default {
  trackForRentContact({ trusted, isApartmentBldg }: TrackingParams = {}): void {
    if (trusted) {
      if (isApartmentBldg) {
        conversion('ux1QCMWOucgDEP7tvJQD');
      } else {
        conversion('GGbbCPuCsHIQ_u28lAM');
      }
    } else if (!trusted && isApartmentBldg) {
      conversion('foAwCJbdtHMQ_u28lAM');
    } else {
      conversion('YypeCKOCyHIQ_u28lAM');
    }
  },

  trackForRentPhoneContact({ trusted, isApartmentBldg }: TrackingParams = {}): void {
    if (isApartmentBldg) {
      // Paid MF Calls
      conversion('9ldvCJG_rn0Q_u28lAM');
    } else if (trusted) {
      // Paid Non-MF For Rent Calls
      conversion('fR0ACNTGwX0Q_u28lAM');
    } else {
      // Unpaid For Rent Calls
      conversion('kWTdCMjGwX0Q_u28lAM');
    }
  },

  trackPayPerClick(): void {
    // CPC clicks
    conversion('pHZyCND1xX0Q_u28lAM');
  },
};
